import Const from 'constants';

let PlayersPosition = {
    setPlayersPositionFromStorage(payload) {
        return (dispatch) => {
            dispatch(this.changePlayersPosition(payload, {saveToStorage: false}));
        };
    },
    changePlayersPosition(payload, options = {}) {
        return (dispatch) => {
            const {saveToStorage = true} = options;

            dispatch({
                type: Const.CHANGE_PLAYERS_POSITION,
                payload,
            });

            saveToStorage && dispatch(
                this.saveDataToStorage('playersPosition', (state, storageData) => {
                    storageData = storageData || {};

                    const indexedPlayersPosition = {};
                    Object.values(payload).map((item) => {
                        indexedPlayersPosition[item.playerId] = item;
                    });

                    return {
                        ...storageData,
                        ...indexedPlayersPosition,
                    };
                }),
            );
        };
    },
};

export default PlayersPosition;
